import {
  Box,
  Flex,
  Text,
  Tooltip,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverHeader,
  useDisclosure,
  Badge,
  SimpleGrid,
  Icon,
} from '@chakra-ui/react'
import { FiInfo } from 'react-icons/fi'
import { statusConfig } from '../utils/statusConfig'

export function StatusLegend() {
  const { isOpen, onToggle, onClose } = useDisclosure()

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end" closeOnBlur={true} trigger="click">
      <PopoverTrigger>
        <IconButton
          aria-label="Legenda de status"
          icon={<Icon as={FiInfo} />}
          size="sm"
          colorScheme="blue"
          variant="ghost"
          onClick={onToggle}
          mr={2}
        />
      </PopoverTrigger>
      <PopoverContent width="300px" boxShadow="md">
        <PopoverHeader fontWeight="semibold" fontSize="13px" textAlign="center" borderBottomWidth="1px">
          Legenda de Status
        </PopoverHeader>
        <PopoverBody p={3}>
          <SimpleGrid columns={2} spacing={2}>
            {Object.entries(statusConfig).map(([status, config]) => (
              <Flex key={status} align="center" p={1} borderRadius="md" _hover={{ bg: 'gray.50' }}>
                <Badge colorScheme={config.colorScheme} mr={2} p={1}>
                  &nbsp;&nbsp;&nbsp;
                </Badge>
                <Tooltip label={config.description} hasArrow placement="top">
                  <Text fontSize="12px" noOfLines={1} cursor="help">
                    {status}
                  </Text>
                </Tooltip>
              </Flex>
            ))}
          </SimpleGrid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
